import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axios';
import { URLS } from 'constants/api.constants';

export const groupGet = createAsyncThunk(
  'group/groupget',
  async (params = {}, thunkAPI) => {
    try {
      const response = await axiosInstance.get(URLS.GROUP.GET_GROUP, {
        params: {
          ...params,
          page: params.page || 1,
          limit: params.limit || 10
        }
      });
      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch group'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching group'
      );
    }
  }
);

export const getMyGroup = createAsyncThunk(
  `group/getMyGroup`,
  async (params = {}, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        URLS.GROUP.GET_MY_GROUPS,
        {
          params: {
            ...params,
            page: params.page || 1,
            limit: params.limit || 10
          }
        }
      );
      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch mu groups'
        );
      }
    } catch (error) {
      console.log('My group api error: ', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching my group'
      );
    }
  }
);

export const createGroup = createAsyncThunk(
  'group/creategroup',
  async (params = {}, thunkAPI) => {
    try {
      const response = await axiosInstance.post(URLS.GROUP.CREATE_GROUP, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch group'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching group'
      );
    }
  }
);

export const modifyOwner = createAsyncThunk(
  'group/modifyowner',
  async (params = {}, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        URLS.GROUP.MODIFY_OWNER,
        params
      );

      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch group'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching group'
      );
    }
  }
);

export const removeMember = createAsyncThunk(
  'group/removememnber',
  async (params = {}, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        URLS.GROUP.REMOVE_MEMBER,
        params
      );
      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch group'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching group'
      );
    }
  }
);

export const addMember = createAsyncThunk(
  'group/addmember',
  async (params = {}, thunkAPI) => {
    try {
      const response = await axiosInstance.post(URLS.GROUP.ADD_MEMBER, params);
      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch group'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching group'
      );
    }
  }
);

export const getTags = createAsyncThunk(
  'group/gettags',
  async (params = {}, thunkAPI) => {
    try {
      const response = await axiosInstance.get(URLS.GROUP.GET_TAGS, params);

      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch group'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching group'
      );
    }
  }
);

export const reportGroup = createAsyncThunk(
  'group/reportgroup',
  async (params = {}, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        URLS.GROUP.REPORT_GROUP,
        params
      );

      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to report group'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while reporting group'
      );
    }
  }
);

export const deleteGroup = createAsyncThunk(
  'group/deletegroup',
  async (group_id, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${URLS.GROUP.DELETE_GROUP}/${group_id}`
      );

      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to delete group'
        );
      }
    } catch (error) {
      console.error('Delete group API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while deleting group'
      );
    }
  }
);

export const getGroupDetails = createAsyncThunk(
  'group/getgroupdetails',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${URLS.GROUP.GET_GROUP_DATA}/${id}`
      );
      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch group'
        );
      }
    } catch (error) {
      console.error('feedback API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching group'
      );
    }
  }
);

export const getCommentDetail = createAsyncThunk('group/getcommentdetail',async(id,thunkAPI) => {
  try {
    const response = await axiosInstance.get(`${URLS.POSTS.GET_COMMENT_DETAIL}/${id}`);
    if(response.data?.success){
      return response.data;
    }else{
      return thunkAPI.rejectWithValue(
        response.data?.message || 'Failed to fetch comment'
      );
    }
  } catch (error) {
    console.error('feedback API Error:', error);
    return thunkAPI.rejectWithValue(
      error?.message || 'An error occurred while fetching comment'
    );
  }
})

export const exitGroup = createAsyncThunk('group/exitGroup',async(groupId,thunkAPI) => {
  try {
    const response = await axiosInstance.post(
      `${URLS.GROUP.EXIT_GROUP}/${groupId}/exit`
    );
    if (response.data?.success) {
      return response.data;
    } else {
      return thunkAPI.rejectWithValue(
        response.data?.message || 'Failed to exit group'
      );
    }
  } catch (error) {
    console.error('feedback API Error:', error);
    return thunkAPI.rejectWithValue(
      error?.message || 'An error occurred while exiting group'
    );
  }
})
